import { eTransferCore as _etransferCore } from '@etransfer/core';

export const etransferCore = _etransferCore;
